import React from 'react';
import { useTranslation } from 'react-i18next';
import { BaseCard } from './BaseCard';
import { TotalReturnsCardProps } from './CardProps';
import { DASHBOARD_CARD_TITLE_KEYS } from './dashboardCardKeys';
import { DashboardMetricContent } from './DashboardMetricContent';
import { DataLogStatus } from 'store/app/enums';

export const TotalReturnsCard: React.FC<TotalReturnsCardProps> = ({
  cardId,
  mappedReturns,
  dashboardViewType,
  currentUser,
  onClick,
}) => {
  const { t } = useTranslation();
  const cardTitle = t(DASHBOARD_CARD_TITLE_KEYS[cardId]!);

  const shouldIncludeReturn = (item: any) => {
    if (dashboardViewType === 'manager') return true;
    return (
      item.dataLog?.preparerUser?.userUuid === currentUser?.userUuid ||
      item.dataLog?.reviewerUser?.userUuid === currentUser?.userUuid ||
      item.dataLog?.clientUser?.userUuid === currentUser?.userUuid
    );
  };

  const getAllReturns = React.useMemo(() => {
    return (
      mappedReturns?.filter(
        (item) =>
          shouldIncludeReturn(item) && item.status !== DataLogStatus.SUBMITTED
      ) || []
    );
  }, [mappedReturns, dashboardViewType, currentUser]);

  return (
    <BaseCard cardId={cardId} title={null} onClick={onClick}>
      <DashboardMetricContent label={cardTitle} value={getAllReturns.length} />
    </BaseCard>
  );
};
